import {
    Button as AntButton,
    Col,
    Drawer,
    Form,
    Image,
    Modal,
    Popconfirm,
    Row,
    Switch,
    Table,
    Tooltip,
    Upload,
    UploadFile,
    notification,
    Select, Input, InputNumber
} from 'antd';
import { ColumnsType } from 'antd/es/table';
import { RcFile, UploadProps } from 'antd/es/upload';
import React, { useEffect, useState } from 'react';
import { Button } from "react-bootstrap";
import { Icon } from 'ts-react-feather-icons';
import { UserRole } from '../../constants/userRole';
import {
    deleteEpisodeImage,
    genImageByAI, genImageCoverByAI,
    getEpisodeImages,
    updateEpisodeImage,
    uploadEpisodeImages
} from '../../helpers/api/story';
import { useUser } from '../../hooks';
import User from '../../model/User';
import CustomPagination from '../CustomPagination';
import TextArea from "antd/es/input/TextArea";

interface EpisodeImageModel {
    key: React.Key;
    id: string;
    url: string;
    status: string;
    type: string;
    createdAt: Date;
    modifiedAt: Date;
    prompt: string;
    episodeId: string;
    seedId: number;
}

const EpisodeImageDrawer = ({
                                storyId,
                                drawerVisibility,
                                setdDrawerVisibility,
                                episodeDetail,
                            }: any) => {
    const currentLoggedInUser = useUser().user as User || null;

    const [form] = Form.useForm();
    const formValueObj = Form.useWatch([], form);

    const [submittables, setSubmittable] = useState<boolean>(false);
    const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
    const [pageSize, setPageSize] = useState<number>(10);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [episodeImages, setEpisodeImages] = useState<any[]>([]);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);

    const [api, contextHolder] = notification.useNotification();
    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    // for image
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [images, setImages] = useState<UploadFile[]>([]);

    // images
    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        const tempFiles: UploadFile<any>[] = [];
        newFileList.forEach(f => {
            const existedFiles = tempFiles.filter(e => e.name === f.name);
            if (existedFiles && existedFiles.length > 0) {
                return;
            }
            tempFiles.push(f);
        });
        setImages(tempFiles);
    }

    const uploadButton = (
        <div>
            {/* <PlusOutlined rev={1} /> */}
            <Icon name="plus" size={16} />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    const [openPopupGenImageAI, setOpenPopupGenImageAI] = useState(false);
    const [charactersAi, setCharactersAi] = useState<any>(null);
    const [characterAiGenImage, setCharacterAiGenImage] = useState<any>(null);
    const [episodeImageId, setEpisodeImageId] = useState<any>(null);
    const [openPopupReGenImageAI, setOpenPopupReGenImageAI] = useState(false);

    const [openPopupGenImageAICover, setOpenPopupGenImageAICover] = useState(false);


    useEffect(() => {
        form.validateFields({ validateOnly: true })
            .then(
                () => { setSubmittable(images.length > 0) },
                () => { setSubmittable(false) },
            );
    }, [formValueObj, images]);

    useEffect(() => {
        if (!episodeDetail) {
            form.setFieldValue("status", "inactive");
            return;
        }
        form.setFieldsValue({ ...episodeDetail });
        setCharactersAi(episodeDetail.characters.filter((e: any) => e.type === 'ai_character'));
        setCharacterAiGenImage(episodeDetail.characters.filter((e: any) => e.type === 'ai_character')[0]?.id);
        search();
    }, [episodeDetail]);

    const onClose = () => {
        form.resetFields();
        setImages([]);
        setSubmittable(false);
    }

    const uploadImages = async () => {
        try {
            form.validateFields();
            setLoadingBtn(true);
            let response;
            const formData = new FormData();
            images.forEach(img => {
                formData.append("images", img.originFileObj as Blob, img.originFileObj?.name);
            });
            response = await uploadEpisodeImages(storyId, episodeDetail.id, formData);

            setLoadingBtn(false);
            if (response?.status === 200) {
                api.success({
                    message: `Successfull notification`,
                    description: 'Upload episode image(s) successfully!',
                    placement: 'topRight'
                });
                setImages([]);
                search();
                return;
            }
        } catch (err) {
            console.log(err);
            showError(err as string);
        }
        setLoadingBtn(false);
    }


    const columns: ColumnsType<EpisodeImageModel> = [
        {
            title: "No.",
            dataIndex: "noNumber"
        },
        {
            title: "Image",
            dataIndex: "name",
            render: (text, record, index) => {
                return (
                    <Tooltip title={record.prompt}>
                        <span>
                            <Image
                                width={50}
                                src={`${record.url}?t=${new Date().getTime()}`}
                            />
                        </span>
                    </Tooltip>
                )
            },
        },
        {
            title: 'Seed ID',
            dataIndex: 'seedId',
        },
        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Published?",
            dataIndex: "activated",
            render: (text, record, index) => {
                return (
                    <Popconfirm
                        title={`${record.status === "active" ? "Hide" : "Show"} episode image`}
                        description={`Are you sure to ${record.status === "active" ? "hide" : "show"} this episode image?`}
                        onConfirm={() => changeImageVisibility(record, record.status)}
                        okText="OK"
                        cancelText="Cancel"
                    >
                        <Switch checked={record.status === 'active'}
                                disabled={
                                    (!currentLoggedInUser?.roles?.includes(UserRole.SUPER_ADMIN)
                                        && !currentLoggedInUser?.roles?.includes(UserRole.ADMIN))
                                    || (record.type === "default" && (record.status === "pending" || record.status === "rejected" || record.status === "deleted"))
                                }
                        />
                    </Popconfirm>
                )
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (text, record, index) => {
                return (
                    <>
                        {
                            (currentLoggedInUser?.roles?.includes(UserRole.SUPER_ADMIN) || currentLoggedInUser?.roles?.includes(UserRole.ADMIN))
                            && record.type !== "default_image" && (
                                <>
                                    <Popconfirm
                                        title={`Set as default image`}
                                        description={`Are you sure to set this image to default?`}
                                        onConfirm={() => setAsDefaultImage(record)}
                                        okText="OK"
                                        cancelText="Cancel"
                                    >
                                        <Tooltip title="Set as default image">
                                            <span role="button" className='d-inline-block me-2'>
                                                <Icon name="check-circle" color="#1abc9c" size={16} />
                                            </span>
                                        </Tooltip>
                                    </Popconfirm>
                                </>
                            )
                        }
                        {!record.seedId && (
                            <Tooltip title="Regenerate image">
                        <span role="button" className='d-inline-block me-2' onClick={() => {
                            setEpisodeImageId(record.id);
                            setCharacterAiGenImage('');
                            form.resetFields();
                            setOpenPopupReGenImageAI(true);
                        }}>
                            <Icon name="repeat" color="#1abc9c" size={16}/>
                        </span>
                            </Tooltip>
                        )}
                        {
                            (currentLoggedInUser?.roles?.includes(UserRole.SUPER_ADMIN) || currentLoggedInUser?.roles?.includes(UserRole.ADMIN)) &&
                            record.type !== "default" && (
                                <>
                                    <Popconfirm
                                        title={`Delete episode image`}
                                        description={`Are you sure to delete this episode image?`}
                                        onConfirm={() => triggerDeleteEpisodeImage(record)}
                                        okText="OK"
                                        cancelText="Cancel"
                                    >
                                        <Tooltip title="Delete episode image">
                                            <span role="button" className='d-inline-block me-2'>
                                                <Icon name="trash-2" color="red" size={16} />
                                            </span>
                                        </Tooltip>
                                    </Popconfirm>
                                </>
                            )
                        }
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        if (!episodeDetail) {
            return;
        }
        search();
    }, [pageIndex]);

    useEffect(() => {
        if (!episodeDetail) {
            return;
        }
        if (pageIndex === 1) {
            search();
            return;
        }
        setPageIndex(1);
    }, [pageSize]);


    const search = async () => {
        setSearchLoading(true);
        const searchObj: any = {
            pageIndex: pageIndex - 1,
            pageSize,
        };
        try {
            const response = await getEpisodeImages(episodeDetail.storyId, episodeDetail.id, searchObj);
            if (response.status === 200) {
                const data: any[] = await Promise.all(
                    response.data.data.map(async (item: any, index: number) => {
                        return {
                            ...item,
                            noNumber: (pageIndex - 1) * pageSize + index + 1,
                        };
                    })
                );
                setEpisodeImages(data);
                setTotalRecord(response.data.totalRecord);
            }
        } catch (err) {
            console.error(err);
            api.error({
                message: `Error notification`,
                description: <span className="text-danger">{err as string || 'There\'re some errors occured!'}</span>,
                placement: 'topRight'
            });
        }
        setSearchLoading(false);
    }

    const changeImageVisibility = async (episodeImage: EpisodeImageModel, currentStatus: string) => {
        try {
            debugger;
            let isLandscape = false;

            if (episodeImage?.url) {
                try {
                    const imageSize = await getImageSizeFromUrl(`${episodeImage.url}?t=${new Date().getTime()}`);
                    isLandscape = imageSize.width > imageSize.height;
                } catch (err) {
                    console.error("Lỗi khi load ảnh:", err);
                    // fallback tùy bạn xử lý
                }
            } else {
                console.warn("episodeImage.url không hợp lệ");
            }
            const response = await updateEpisodeImage(episodeDetail.storyId, episodeImage.episodeId, episodeImage.id, { status: currentStatus == "inactive" ? "active" : "inactive",
                isLandscape: isLandscape});
            if (response.status === 200) {
                api.success({
                    message: `Successfull notification`,
                    description: (currentStatus === "activated" ? 'Deactivate' : 'Activate') + ' episode image successfully!',
                    placement: 'topRight'
                });
                search();
            }
        } catch (err) {
            console.error(err);
            showError(err as string);
        }

    }

    const setAsDefaultImage = async (episodeImage: EpisodeImageModel) => {
        try {
            const response = await updateEpisodeImage(episodeDetail.storyId, episodeImage.episodeId, episodeImage.id, { type: "default_image" });
            if (response.status === 200) {
                api.success({
                    message: `Successfull notification`,
                    description: 'Set episode default image successfully!',
                    placement: 'topRight'
                });
                search();
            }
        } catch (err) {
            console.error(err);
            showError(err as string);
        }

    }

    const triggerDeleteEpisodeImage = async (episodeImage: EpisodeImageModel) => {
        const response = await deleteEpisodeImage(episodeDetail.storyId, episodeImage.episodeId, episodeImage.id);
        if (response.status === 200) {
            api.success({
                message: `Successfull notification`,
                description: 'Set episode default image successfully!',
                placement: 'topRight'
            });
            search();
        }
    }

    const triggerGenImageAI = async () => {
        setLoadingBtn(true);
        const request = {
            characterId: characterAiGenImage,
            prompt: formValueObj.prompt,
            typeGen: "episode",
            episodeId: episodeDetail.id,
            numberOfImages: formValueObj.numberImages || 3
        }
        try {
            const response = await genImageByAI(storyId,request);
            if (response.status === 200) {
                api.success({
                    message: `Successfull notification`,
                    description: 'Generate image by AI successfully!',
                    placement: 'topRight'
                });
                setOpenPopupGenImageAI(false)
                search();
            }
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
        setLoadingBtn(false);
        setOpenPopupGenImageAI(false);
    }

    const triggerGenImageCoverNew = async () => {
        setSearchLoading(true);
        const request = {
            prompt: formValueObj.promptCover,
            numberOfImages: formValueObj.numberImagesCover || 2
        }
        try {
            const response = await genImageCoverByAI(storyId,episodeDetail.id,request);
            if (response.status === 200) {
                api.success({
                    message: `Successfull notification`,
                    description: 'Generate image by AI successfully!',
                    placement: 'topRight'
                });
                search();
            }
        } catch (err) {
            console.log(err);
            showError(err as string);
        }
        setSearchLoading(false);
        setOpenPopupGenImageAICover(false);

    }

    const getImageSizeFromUrl = async (url: string) => {
        return new Promise<{ width: number; height: number }>((resolve, reject) => {
            const img = new window.Image();
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.onerror = (error) => {
                reject(error);
            };
            img.src = url;
        });
    };


    const triggerReGenImage = async () => {
        setLoadingBtn(true);
        const image = episodeImages.find((e: any) => e.id === episodeImageId);
        const imageSize = await getImageSizeFromUrl(`${image.url}?t=${new Date().getTime()}`) as { width: number, height: number };
        if (imageSize.width > imageSize.height) {
            const request = {
                numberOfImages: formValueObj.numberImages || 2
            }
            try {
                const response = await genImageCoverByAI(storyId,episodeDetail.id,request);
                if (response.status === 200) {
                    api.success({
                        message: `Successfull notification`,
                        description: 'Generate image by AI successfully!',
                        placement: 'topRight'
                    });
                    search();
                }
            } catch (err) {
                console.log(err);
                showError(err as string);
            }
        } else {
            const request = {
                characterId: characterAiGenImage,
                typeGen: "episode",
                episodeId: episodeDetail.id,
                episodeImageId: episodeImageId,
                numberOfImages: formValueObj.numberImages || 2
            }

            try {
                const response = await genImageByAI(storyId,request);
                if (response.status === 200) {
                    api.success({
                        message: `Successfull notification`,
                        description: 'Generate image by AI successfully!',
                        placement: 'topRight'
                    });
                    search();
                }
            } catch (err) {
                console.log(err);
                showError(err as string);
            }
        }

        setLoadingBtn(false);
        setOpenPopupReGenImageAI(false);

    }

    return (
        <Drawer
            title={"Episode images"}
            className='character-drawer'
            width={750}
            onClose={() => { setdDrawerVisibility(false) }}
            open={drawerVisibility}
            closeIcon={false}
        >
            {contextHolder}
            <Form layout="vertical" autoComplete='off' form={form}>
                <Row gutter={16} className='d-flex justify-content-center'>
                    <Form.Item
                        name="image"
                        label="Image"
                    >
                        <Upload
                            listType="picture-card"
                            fileList={images}
                            onPreview={handlePreview}
                            onChange={handleChange}
                            multiple={false}
                            accept="image/png, image/jpeg, image/jpg"
                        >
                            {images.length >= 5 ? null : uploadButton}
                        </Upload>
                        <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                            <img alt="example" style={{ width: '100%' }} src={previewImage} />
                        </Modal>
                    </Form.Item>
                </Row>
                <Row gutter={16} className='d-flex justify-content-center'>
                    <AntButton onClick={uploadImages} type="primary" className='me-3' disabled={!submittables} loading={loadingBtn}>
                        Upload
                    </AntButton>
                    <AntButton onClick={onClose}>Cancel</AntButton>
                </Row>
            </Form>

            <Row className='mt-5 mb-1'>
                <Col>
                    <Button variant="success" className="mb-1 py-1 me-1" onClick={() => {
                        search();
                    }}>
                        <i className="mdi mdi-refresh me-1"></i> Refresh
                    </Button>
                    <Button variant="secondary" className="mb-1 py-1 me-1" onClick={() => {
                        setCharacterAiGenImage('');
                        form.resetFields();
                        setOpenPopupGenImageAI(true);
                    }}>
                        <i className="mdi mdi-creation"></i> Gen Image AI
                    </Button>
                    <Button variant="primary" className="mb-1 py-1 me-1" onClick={() => {
                        form.resetFields();
                        setOpenPopupGenImageAICover(true);
                    }}>
                        <i className="mdi mdi-creation"></i> Gen Image Cover AI
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col className='w-100'>
                    <Table
                        loading={searchLoading}
                        rowKey={"noNumber"}
                        className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                        dataSource={episodeImages}
                        columns={columns}
                        pagination={false}
                    />

                    {episodeImages?.length !== 0 && (
                        <CustomPagination
                            pageIndex={pageIndex}
                            pageSize={pageSize}
                            totalItem={totalRecord}
                            setPageSize={setPageSize}
                            setPageIndex={setPageIndex}
                        />
                    )}
                </Col>
            </Row>

            <Modal
                centered={true}
                title="Generate Image by AI"
                open={openPopupGenImageAI}
                confirmLoading={loadingBtn}
                onOk={() => triggerGenImageAI()}
                onCancel={() => setOpenPopupGenImageAI(false)}
            >

                <Form layout="vertical" autoComplete='off' form={form}>
                    <Row gutter={16} className='mb-3'>
                        <Col span={24}>
                            <Form.Item
                                name="character"
                                label="Character"
                            >
                                <Select
                                    style={{ width: 200 }}
                                    placeholder="Select a character"
                                    value={characterAiGenImage}
                                    onChange={(value) => setCharacterAiGenImage(value)}
                                >
                                    {charactersAi?.map((item: any) => (
                                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} className='mb-3'>
                        <Col span={24}>
                            <Form.Item
                                name="numberImages"
                                label="Number of images"
                            >
                                <InputNumber min={1} max={5} defaultValue={3} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} className='mb-3'>
                        <Col span={24}>
                            <Form.Item
                                name="prompt"
                                label="Prompt"
                            >
                                <TextArea rows={4} placeholder="Enter prompt" maxLength={5000} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </Modal>

            <Modal
                centered={true}
                title="Re-Generate Image by AI"
                open={openPopupReGenImageAI}
                confirmLoading={loadingBtn}
                onOk={() => triggerReGenImage()}
                onCancel={() => setOpenPopupReGenImageAI(false)}
            >

                <Form layout="vertical" autoComplete='off' form={form}>
                    <Row gutter={16} className='mb-3'>
                        <Col span={24}>
                            <Form.Item
                                name="character"
                                label="Character"
                            >
                                <Select
                                    style={{ width: 200 }}
                                    placeholder="Select a character"
                                    value={characterAiGenImage}
                                    onChange={(value) => setCharacterAiGenImage(value)}
                                >
                                    {charactersAi?.map((item: any) => (
                                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} className='mb-3'>
                        <Col span={24}>
                            <Form.Item
                                name="numberImages"
                                label="Number of images"
                            >
                                <InputNumber min={1} max={5} defaultValue={3} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </Modal>

            <Modal
                centered={true}
                title="Generate Image by AI"
                open={openPopupGenImageAICover}
                confirmLoading={loadingBtn}
                onOk={() => triggerGenImageCoverNew()}
                onCancel={() => setOpenPopupGenImageAICover(false)}
            >

                <Form layout="vertical" autoComplete='off' form={form}>
                    <Row gutter={16} className='mb-3'>
                        <Col span={24}>
                            <Form.Item
                                name="numberImagesCover"
                                label="Number of images"
                            >
                                <InputNumber min={1} max={5} defaultValue={2} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} className='mb-3'>
                        <Col span={24}>
                            <Form.Item
                                name="promptCover"
                                label="Prompt"
                            >
                                <TextArea rows={4} placeholder="Enter prompt" maxLength={5000} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </Modal>
        </Drawer>
    )

}

export default EpisodeImageDrawer;
